export default function AboutSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%2C%20warm%20natural%20sunlight%20streaming%20through%20window%2C%20minimalist%20workspace%20with%20ceramic%20coffee%20cup%2C%20soft%20cream%20and%20coral%20accents%2C%20elegant%20composition%2C%20no%20text%20on%20screen%2C%20gentle%20shadows%2C%20airy%20editorial%20style%2C%20productive%20atmosphere&width=800&height=600&seq=yoybuy-about-v2-01&orientation=landscape"
              alt="Yoybuy Sheet workspace"
              className="w-full rounded-2xl object-cover"
            />
          </div>
          <div className="lg:w-1/2">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-5">
              Что такое Yoybuy Sheet?
            </h2>
            <div className="space-y-4">
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                <strong className="text-foreground-950">Yoybuy Sheet</strong> — это подробные таблицы со ссылками на лучшие товары, доступные для заказа через Yoybuy. Каждая таблица содержит проверенные ссылки на качественные товары от надёжных продавцов.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Наши таблицы охватывают широкий спектр категорий: от обуви и одежды до аксессуаров и парфюмерии. Мы постоянно обновляем списки, чтобы вы всегда имели доступ к самым актуальным находкам.
              </p>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                Yoybuy — это удобный агент для заказа товаров из Китая. С нашими таблицами вы можете быстро находить нужные товары и оформлять заказы без лишних хлопот.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}